import React from "react"
import { injectIntl } from "react-intl"
import {
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Grid,
} from "@material-ui/core"
import Button from "@material-ui/core/Button"
import moment from "moment"
import { makeStyles } from "@material-ui/core/styles"
import { Carsharing } from "@ridecell/web-sdk"

import useGlobalContext from "../../utils/customHooks/useGlobalContext"
import messages from "./messages"

const useStyles = makeStyles((theme) => ({
  cardHeader: {
    backgroundColor: "#F0F0F0",
  },
  currentTrip: {
    height: "80px",
  },
  pastTrips: {
    maxHeight: "500px",
    overflowY: "scroll",
  },
  tripImage: {
    backgroundSize: "contain",
    height: "150px",
  },
  tripInfo: {
    height: "100%",
  },
}))

const TripCard = ({
  current,
  getUpcomingTrips,
  intl: { formatMessage },
  trip,
  upcoming,
}) => {
  const classes = useStyles()
  const {
    state: { tenantSettings },
  } = useGlobalContext()

  const cancelTrip = (id) => {
    Carsharing.cancelScheduledRental({ id })
      .then(() => {
        getUpcomingTrips()
      })
      .catch(() => {})
  }

  const CancelButton = () => (
    <Button
      onClick={() => cancelTrip(trip.id)}
      color="secondary"
      variant="contained"
    >
      {formatMessage(messages.cancel)}
    </Button>
  )

  const formatDateTime = (date) => {
    return moment(date).format(
      tenantSettings.use24hrClock ? "MMM D YYYY HH:mm" : "lll"
    )
  }

  return current ? (
    <Grid item xs={12} spacing={1}>
      <Card>
        <CardHeader
          action={upcoming ? <CancelButton /> : null}
          className={classes.cardHeader}
          title={
            <>
              <strong>{formatMessage(messages.id)}</strong>
              <span>{trip.id}</span>
            </>
          }
          titleTypographyProps={{ variant: "subtitle1" }}
        />
        <CardContent>
          <Grid
            className={classes.currentTrip}
            container
            direction="column"
            justify="space-around"
          >
            {trip.start_station && trip.start_station.name && (
              <Grid item>
                <strong>{formatMessage(messages.station)}</strong>
                <span>{trip.start_station.name}</span>
              </Grid>
            )}
            {trip?.vehicle?.license_plate_number && (
              <Grid item>
                <strong>{formatMessage(messages.license)}</strong>
                <span>{trip?.vehicle?.license_plate_number}</span>
              </Grid>
            )}
            {trip.start_location && trip.start_location.short_display_address && (
              <Grid item>
                <strong>{formatMessage(messages.startLocation)}</strong>
                <span>{trip.start_location.short_display_address}</span>
              </Grid>
            )}
            {trip.start_date_time && (
              <Grid item>
                <strong>{formatMessage(messages.startTime)}</strong>
                <span>{formatDateTime(trip.start_date_time)}</span>
              </Grid>
            )}
            {trip.end_date_time && (
              <Grid item>
                <strong>{formatMessage(messages.endTime)}</strong>
                <span>{formatDateTime(trip.end_date_time)}</span>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  ) : (
    <Grid item xs={12} spacing={1}>
      <Card>
        <CardHeader
          action={upcoming ? <CancelButton /> : null}
          className={classes.cardHeader}
          title={
            <>
              <strong>{formatMessage(messages.id)}</strong>
              <span>{trip.id}</span>
            </>
          }
          titleTypographyProps={{ variant: "subtitle1" }}
        />
        <CardContent>
          <Grid container direction="row" spacing="3">
            <Grid item xs={4}>
              <CardMedia
                className={classes.tripImage}
                title="none"
                image={trip.vehicle_image_uri}
              />
            </Grid>
            <Grid item xs={8}>
              <Grid
                className={classes.tripInfo}
                container
                direction="column"
                justify="space-around"
              >
                {trip.start_station && trip.start_station.name && (
                  <Grid item>
                    <strong>{formatMessage(messages.station)}</strong>
                    <span>{trip.start_station.name}</span>
                  </Grid>
                )}
                {trip.vehicle_license_plate && (
                  <Grid item>
                    <strong>{formatMessage(messages.license)}</strong>
                    <span>{trip.vehicle_license_plate}</span>
                  </Grid>
                )}
                {trip.start_location &&
                  trip.start_location.short_display_address && (
                    <Grid item>
                      <strong>{formatMessage(messages.startLocation)}</strong>
                      <span>{trip.start_location.short_display_address}</span>
                    </Grid>
                  )}
                {trip.start_date_time && (
                  <Grid item>
                    <strong>{formatMessage(messages.startDate)}</strong>
                    <span>{formatDateTime(trip.start_date_time)}</span>
                  </Grid>
                )}
                {trip.end_date_time && (
                  <Grid item>
                    <strong>{formatMessage(messages.endDate)}</strong>
                    <span>{formatDateTime(trip.end_date_time)}</span>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  )
}

export default injectIntl(TripCard)
